import { Alert, Button, Stack } from "@mui/material";
import { forwardRef, useState } from "react";
import Modal, { CommonModalProps } from "..";
import { useTranslation } from "react-i18next";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import DataTable, { CellSize } from "../../Table/table";
import TableCellBool from "../../Table/TableCellBool";
import { useDispatch } from "react-redux";
import { GetWorkflow, GetWorkflows, LoadWorkflow } from "../../../Redux/Reducers/redux-slice-workflow-designer";
import { useSelector } from "react-redux";
import { WarningAmberOutlined } from "@mui/icons-material";

export type ModalLoadWorkflowDiagramDesignerElementProps = {
    onConfirm?: () => void;
};

export type ModalLoadWorkflowDiagramDesignerProps = CommonModalProps<ModalLoadWorkflowDiagramDesignerElementProps>;

const ModalLoadWorkflowDiagramDesigner = forwardRef<any, ModalLoadWorkflowDiagramDesignerProps>((props, ref) => {
    const { t } = useTranslation();
    const { closeModal, onConfirm } = props;
    const dispatch = useDispatch();

    const workflows = useSelector(GetWorkflows);
    const workflow = useSelector(GetWorkflow);
    const [selectedWorkflowId, setSelectedWorkflowId] = useState<number | null>(workflow?.id ?? null);

    const handleCancelClick = () => {
        closeModal();
    };

    const handleConfirmClick = () => {
        dispatch(LoadWorkflow(workflows.find((x) => x.id === selectedWorkflowId)!));
        onConfirm && onConfirm();
        closeModal();
    };

    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: "Id",
            flex: CellSize.small,
            minWidth: CellSize.small,
        },
        {
            field: "name",
            headerName: t("common:name"),
            flex: CellSize.medium,
            minWidth: CellSize.medium,
        },
        {
            field: "description",
            headerName: t("common:description"),
            flex: CellSize.large,
            minWidth: CellSize.large,
        },
        {
            field: "enabled",
            headerName: t("common:enabled"),
            flex: CellSize.small,
            minWidth: CellSize.small,
            renderCell: (params) => <TableCellBool value={params.value} />,
        },
    ];

    return (
        <Modal
            title={"Load Workflow"}
            reference={ref}
            closeModal={handleCancelClick}
            width={980}
            footer={
                <Stack direction="row" justifyContent="space-between">
                    <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
                    <Button color="success" variant="outlined" onClick={handleConfirmClick} disabled={!selectedWorkflowId}>
                        {t("common:confirm")}
                    </Button>
                </Stack>
            }
        >
            <Stack spacing={1}>
                {workflow.name && workflow.name.length > 1 && (
                    <Alert sx={{ display: "flex", alignItems: "center" }} severity="warning" icon={<WarningAmberOutlined />}>
                        {t("alert:warning:saveWorkflowReminder")}
                    </Alert>
                )}
                <DataTable
                    noControls
                    selectedRows={selectedWorkflowId ? [selectedWorkflowId] : []}
                    rows={workflows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    onRowClick={(params: GridRowParams) => setSelectedWorkflowId(params?.row?.id)}
                />
            </Stack>
        </Modal>
    );
});
export default ModalLoadWorkflowDiagramDesigner;
